// Enterprise-identity helpers shared by the account, user-admin and collection
// pages: how an account signs in, which of its fields the identity provider
// (IdP) owns, and how an IdP group is labelled.

export const AUTH_SOURCE_LOCAL = "local";

/** The admin-editable account fields an IdP group mapping can take over
 * (the values of `managed_fields` in /auth/me and /auth/users/{id}/identity). */
export const MANAGED_FIELDS = Object.freeze({
  role: "role",
  database: "database",
  licences: "licences",
});

/** True for accounts that sign in through SSO / are provisioned by SCIM. An
 * account without `auth_source` (an older backend) is treated as local. */
export function isSsoAccount(account) {
  return Boolean(account && account.auth_source && account.auth_source !== AUTH_SOURCE_LOCAL);
}

/** True when `field` of the account is controlled by the IdP. */
export function isManagedField(identity, field) {
  return Boolean(identity && Array.isArray(identity.managed_fields)
    && identity.managed_fields.includes(field));
}

/** A group's human label: its display name, else its external id, else our id. */
export function groupLabel(group) {
  if (!group) return "";
  return group.display_name || group.external_id || group.id || "";
}
